module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), (_vm.frt_enq_id > 0) ? _c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.showEnqModal(_vm.frt_enq_id)
      }
    }
  }, [_vm._v("Update Remark")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "ENQ-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.Page_title
    }
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusList,
      "option-value": "StatusVal",
      "option-text": "StatusText",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.enq_freight.frt_enq_status),
      callback: function($$v) {
        _vm.$set(_vm.enq_freight, "frt_enq_status", $$v)
      },
      expression: "enq_freight.frt_enq_status"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Tentative Sale Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "frt_enq_tentative_sale_date",
      "id": "frt_enq_tentative_sale_date",
      "placeholder": "Enter Tentative Sail Date",
      "not-before": _vm.calculateMinDate()
    },
    model: {
      value: (_vm.enq_freight.frt_enq_tentative_sale_date),
      callback: function($$v) {
        _vm.$set(_vm.enq_freight, "frt_enq_tentative_sale_date", $$v)
      },
      expression: "enq_freight.frt_enq_tentative_sale_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "3",
      "type": "text",
      "placeholder": "Enter Remark"
    },
    model: {
      value: (_vm.enq_freight.frt_enq_remarks),
      callback: function($$v) {
        _vm.$set(_vm.enq_freight, "frt_enq_remarks", $$v)
      },
      expression: "enq_freight.frt_enq_remarks"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [(
    _vm.enq_freight.frt_enq_remarks && _vm.enq_freight.frt_enq_status && _vm.frt_enq_id > 0
  ) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "saveEnquiry"
    },
    on: {
      "click": function($event) {
        _vm.saveEnquiry()
      }
    }
  }, [_vm._v(_vm._s(_vm.frt_enq_id && _vm.frt_enq_id > 0 ? "Update" : "Save"))]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideEnqModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c0af9fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/enqCloseStatus.vue
// module id = 2607
// module chunks = 0